// extracted by mini-css-extract-plugin
export default {"uploadContainer":"FileUpload_uploadContainer__rDaXP","focused":"FileUpload_focused__QPpUG","progressBar":"FileUpload_progressBar__RGH9D","deleteIcon":"FileUpload_deleteIcon__Pk97C"};